import { render, staticRenderFns } from "./PlansPrevention.vue?vue&type=template&id=29a04c41&"
import script from "./PlansPrevention.vue?vue&type=script&lang=ts&"
export * from "./PlansPrevention.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports